
namespace Matrix.Data {

    @Serenity.Decorators.registerClass()
    export class FieldCustomizationDialog extends SiteEntityDialog<FieldCustomizationRow, any> {
        protected getFormKey() { return FieldCustomizationForm.formKey; }
        protected getIdProperty() { return FieldCustomizationRow.idProperty; }
        protected getLocalTextPrefix() { return FieldCustomizationRow.localTextPrefix; }
        protected getNameProperty() { return FieldCustomizationRow.nameProperty; }
        protected getService() { return FieldCustomizationService.baseUrl; }

        protected form = new FieldCustomizationForm(this.idPrefix);

        private editorOptions: Serenity.PropertyGrid;
        private formatterOptions: Serenity.PropertyGrid;

        constructor() {
            super();

            this.createEditorOptionsGrid();
            this.form.EditorType.changeSelect2(e => this.createEditorOptionsGrid());

            this.createFormatterOptionsGrid();
            this.form.FormatterType.changeSelect2(e => this.createFormatterOptionsGrid());
        }

        protected getSaveEntity() {
            var saveEntity = super.getSaveEntity();

            var editorParams = {};
            this.editorOptions.save(editorParams);
            saveEntity.EditorParams = editorParams;

            var formatterParams = {};
            this.formatterOptions.save(formatterParams);
            saveEntity.FormatterParams = formatterParams;

            return saveEntity;
        }

        private createEditorOptionsGrid() {
            var el: JQuery;
            if (this.editorOptions) {
                el = this.editorOptions.element;
                this.editorOptions.destroy();
                this.editorOptions = null;
                el.html('');
            }
            else
                el = $('<div/>').insertAfter(this.form.EditorType.element.closest(".category"));

            var items: Serenity.PropertyItem[];
            var editorType = this.form.EditorType.value;
            if (editorType) {
                var et = Q.getLookup<DataReportEditorTypeItem>("Data.DataReportEditorType")
                    .itemById[editorType];
                if (et)
                    items = et.Options;
            }

            items = Q.deepClone(items || []);
            items.forEach((x, i) => {
                if (x.editorType == "Boolean")
                    x.editorType = "Serenity.YesNoCheckEditor";
                x.formCssClass = Q.trim((x.formCssClass || '') + " col-sm-6");
            });

            var index = Q.indexOf(items, x => x.name == "lookupKey");
            if (index > 0) {
                var item = items[index];
                items.splice(index, 1);
                items.splice(0, 0, item);
            }

            this.editorOptions = new Serenity.PropertyGrid(el, {
                items: items,
                mode: Serenity.PropertyGridMode.insert,
                idPrefix: this.idPrefix + "EditOpt_"
            });

            this.editorOptions.load({});
        }

        private createFormatterOptionsGrid() {
            var el: JQuery;
            if (this.formatterOptions) {
                el = this.formatterOptions.element;
                this.formatterOptions.destroy();
                this.formatterOptions = null;
                el.html('');
            }
            else
                el = $('<div/>').insertAfter(this.form.FormatterType.element.closest(".category"));

            var items: Serenity.PropertyItem[];
            var formatterType = this.form.FormatterType.value;
            if (formatterType) {
                var et = Q.getLookup<DataReportFormatterTypeItem>("Data.DataReportFormatterType")
                    .itemById[formatterType];
                if (et)
                    items = et.Options;
            }

            items = Q.deepClone(items || []);
            items.forEach((x, i) => {
                if (x.editorType == "Boolean")
                    x.editorType = "Serenity.YesNoCheckEditor";
                x.formCssClass = Q.trim((x.formCssClass || '') + " col-sm-6");
            });


            var index = Q.indexOf(items, x => x.name == "lookupKey");
            if (index > 0) {
                var item = items[index];
                items.splice(index, 1);
                items.splice(0, 0, item);
            }

            this.formatterOptions = new Serenity.PropertyGrid(el, {
                items: items,
                mode: Serenity.PropertyGridMode.insert,
                idPrefix: this.idPrefix + "FmtOpt_"
            });

            this.formatterOptions.load({});
        }

        loadEntity(entity: FieldCustomizationRow) {

            this.form.FieldName.cascadeField = FieldCustomizationRow.Fields.RowCode;
            this.form.FieldName.cascadeValue = entity == null ? null : entity.RowCode;

            super.loadEntity(entity);

            this.createEditorOptionsGrid();
            this.editorOptions.load(entity.EditorParams || "{}");

            this.createFormatterOptionsGrid();
            this.formatterOptions.load(entity.FormatterParams || "{}");
        }

    }
}